import React from "react";
import { IAdmissionPolicyData } from "../exports/interfaces";

const AdmissionPolicy = ({
  admissionPolicy,
}: {
  admissionPolicy: IAdmissionPolicyData[];
}) => {
  return (
    <div style={{ fontSize: "16px" }}>
      <h4 style={{ textAlign: "center", fontSize: "18px" }}>
        {admissionPolicy[0]?.title}
      </h4>
      <h4 style={{ textAlign: "center", fontSize: "18px" }}>
        {admissionPolicy[0]?.sub_title}
      </h4>

      <br />

      <div
        dangerouslySetInnerHTML={{
          __html: admissionPolicy[0]?.description,
        }}
      />
    </div>
  );
};

export default AdmissionPolicy;
